import { Box } from "@mui/material";
import { replaceDescriptionPlaceholders } from "../components/enum/descriptionUtils";

const renderMarkdownBold = (text) =>
  text.split(/(\*\*[^*]+\*\*)/g).map((part, index) => {
    const isBold = part.startsWith("**") && part.endsWith("**");

    return isBold ? <strong key={index}>{part.slice(2, -2)}</strong> : part;
  });

const DescriptionField = ({ schema, uiSchema = {}, formContext = {} }) => {
  const { description } = schema;
  const uiDescription = uiSchema["ui:description"];
  const resolvedDescription = replaceDescriptionPlaceholders(
    description,
    formContext?.formData,
  );
  const resolvedUiDescription = replaceDescriptionPlaceholders(
    uiDescription,
    formContext?.formData,
  );

  return (
    <Box mt={1} mb={1}>
      {resolvedDescription && (
        <Box mt={1} mb={1} sx={{ whiteSpace: "pre-wrap" }}>
          {typeof resolvedDescription === "string"
            ? renderMarkdownBold(resolvedDescription)
            : resolvedDescription}
        </Box>
      )}

      {!resolvedDescription && resolvedUiDescription && (
        <Box mt={1} mb={1}>
          {resolvedUiDescription}
        </Box>
      )}
    </Box>
  );
};

export default DescriptionField;


